import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Input from '../../TravellerContactInfo/FormFields/Input';
import '../LoginModals.css';
import { If } from 'react-extras';
import { customStyles, UserFlowModalState } from '../../UserFlow/UserFlowModal';

const initialStates = {
  showModal: true,
  validationFail: true,
  errorMessage: '',
};

function GetPasswordFailureStandAlone (props: UserFlowModalState) {
  const [ state, setState ] = useState(initialStates);

  useEffect(() => {
    resolveErrorMessage();
  }, []);

  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  const userNameVerified = () => {
    props.updateVerifiedUser(props.userStatus.userId);
  };

  const resolveErrorMessage = () => {
    const { error } = props.userStatus;
    if (error.includes('OTP')) {
      setState({
        ...state,
        errorMessage: 'You have sent too many password requests for this username.',
      });
    } else {
      setState({
        ...state,
        errorMessage: 'This phone number and username are not linked.',
      });
    }
  };

  const goToIRCTCRegistrationPage = () => {
    props.createAccount();
  };

  const { userStatus: { userId, mobileEntered }, switchModal, allowClose } = props;
  const { showModal, validationFail, errorMessage } = state;

  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals htmlv2"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <div className="singlePanel">
        <If condition={allowClose === true}>
          <p className="textRight modalCloseCont">
            <span
              className="modalClose railSprite crossIcon"
              onClick={closeModal}
            />
          </p>
        </If>

        <p className="font20 latoBold darkGreyText appendBottom10">Reset IRCTC Password</p>
        <p className="font14 appendBottom20">Enter the mobile number registered with your IRCTC account and get password (in 4-5 mins).</p>

        <div className="makeFlex spaceBetween end appendBottom10">
          <Input
            labelName="MOBILE NUMBER"
            errorMessage={errorMessage}
            validationFail
            type="text"
            additionalAttributes={{ placeholder: mobileEntered }}
            fieldId="IRCTCUserName"
            fieldName="IRCTCUserName"
            vaidationMsg=""
            vaidationMoreMsg="Change"
            vaidationMoreStatus={false}
            vaidationStatus
            readOnly
            irctcUserId={userId}
            mobileNumber={mobileEntered}
            switchModal={switchModal}
            onChangePage="forgotPasswordStandalone"
          />
        </div>

        <div className="appendBottom30 end">

          <p className="font14 darkGreyText paddingT20 appendBottom5">Facing trouble?</p>
          <p className="appendBottom40"><a className="font16 latoBold " onClick={goToIRCTCRegistrationPage}>Create New Account</a></p>

        </div>
      </div>
    </Modal>
  );
};
export default GetPasswordFailureStandAlone;
